import { useState, useEffect } from 'react'
import axios from 'axios'
import { useFormik } from 'formik'
import { toast } from 'react-toastify';
import { commonMessage, statusCodes } from '../../../Constants/generalConfig';
import { stateValidation } from '../../../Context/validation';
import { countryList, stateDetails, stateUpdate ,logOutApi} from '../../../Context/api';
import { useNavigate, useParams } from 'react-router-dom';

const UseEditState = () => {
    const [countryData, setCountryData] = useState([])
    const [spinner, setSpinner] = useState(false)
    const { id } = useParams()
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const navigate=useNavigate()
    useEffect(() => {
        countryListData()
        stateView()
    }, [])

    const logOutFun = () => {
        axios.post(logOutApi(), { deviceId: adminData.deviceId }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                localStorage.removeItem('adminData')
                navigate('/')
            }
        })
    }
    const countryListData = () => {
        axios.post(countryList(), { id: adminData.userId, isDeleted: true },{ headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setCountryData(resp.data.data)
            }
        })
    }
    const stateView = () => {
        axios.post(stateDetails(), { id: id },{ headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                stateEdit.setValues(resp.data.data)
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                toast.error(resp.data.message)
            }
        })
    }
    const stateEdit = useFormik({
        initialValues: {
            code: '',
            name: '',
            countryName: '',
        },
        validationSchema: stateValidation,
        onSubmit: (values) => {
            console.log(values);
            const data = {
                id: id,
                name: values.name.trim(),
                code: values.code.trim(),
                createdby_id: adminData.userId,
                countryId: values.countryName,

            }
            setSpinner(true)
            axios.post(stateUpdate(), { ...data },{ headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
                if (resp.data.code === statusCodes.ok) {
                    toast.success(resp.data.message)
                    setSpinner(false)
                    navigate(-1)
                }
                else if (resp.data.code === statusCodes.tokenExpire) {
                    logOutFun()
                }
                else {
                    toast.error(resp.data.message)
                    setSpinner(false)
                }
            }).catch(() => {
                toast.error(commonMessage.networkError)
            })
        }
    })
  return {
    countryData,
    spinner,
    stateEdit

  }
}

export default UseEditState